import styled from "@emotion/styled";

export const MyInfoImgWrapper = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 20px;
  background-image: ${(p) => `url("${p.image}")`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  @media (min-width: 769px) {
    width: 240px;
    height: 240px;
  }
`;
